import { Injectable } from "@angular/core";

import { IMyLocales, IMyOptions } from "../interfaces/index";

@Injectable()
export class LocaleService {
	private locales: IMyLocales = {
		fr: {
			dayLabels: { su: "Dim", mo: "Lun", tu: "Mar", we: "Mer", th: "Jeu", fr: "Ven", sa: "Sam" },
			monthLabels: {
				1: "Jan",
				2: "Fév",
				3: "Mar",
				4: "Avr",
				5: "Mai",
				6: "Juin",
				7: "Juil",
				8: "Aoû",
				9: "Sep",
				10: "Oct",
				11: "Nov",
				12: "Déc",
			},
			dateFormat: "dd/mm/yyyy",
			todayBtnTxt: "Aujourd'hui",
			firstDayOfWeek: "mo",
			sunHighlight: true,
		},
		nl: {
			dayLabels: { su: "Zon", mo: "Maa", tu: "Din", we: "Woe", th: "Don", fr: "Vri", sa: "Zat" },
			monthLabels: {
				1: "Jan",
				2: "Feb",
				3: "Mar",
				4: "Apr",
				5: "Mei",
				6: "Jun",
				7: "Jul",
				8: "Aug",
				9: "Sep",
				10: "Okt",
				11: "Nov",
				12: "Dec",
			},
			dateFormat: "dd-mm-yyyy",
			todayBtnTxt: "Vandaag",
			firstDayOfWeek: "mo",
			sunHighlight: false,
		},
	};

	getLocaleOptions(locale: string): IMyOptions {
		if (locale && this.locales.hasOwnProperty(locale)) {
			// User given locale
			return this.locales[locale];
		}
		// Default: nl
		return this.locales.nl;
	}
}
